import styled from 'styled-components';
import { getSizeStyles } from '../utils/modalHelpers';

export const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${props => (props.theme.zIndex && props.theme.zIndex.modal) || 1050};
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'};
`;

export const ModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: ${props => (props.theme.radii && props.theme.radii.lg) || '8px'};
  box-shadow: ${props => (props.theme.shadows && props.theme.shadows.xl) || '0 20px 25px -5px rgba(0, 0, 0, 0.1)'};
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  width: 100%;
  max-width: ${props => getSizeStyles(props.size).width};
  position: relative;
  animation: modalFadeIn 0.2s ease-out;

  @keyframes modalFadeIn {
    from { opacity: 0; transform: translateY(-20px) scale(0.95); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
`;

export const ModalHeader = styled.div`
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'} ${props => (props.theme.spacing && props.theme.spacing.lg) || '24px'};
  border-bottom: 1px solid ${props => (props.theme.colors && props.theme.colors.border) || '#e5e7eb'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  h2 {
    margin: 0;
    font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.lg) || '18px'};
    color: ${props => (props.theme.colors && props.theme.colors.text && props.theme.colors.text.primary) || '#333'};
  }
`;

export const ModalBody = styled.div`
  padding: ${props => (props.theme.spacing && props.theme.spacing.lg) || '24px'};
  overflow-y: auto;
  flex: 1;
`;

export const ModalFooter = styled.div`
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'} ${props => (props.theme.spacing && props.theme.spacing.lg) || '24px'};
  border-top: 1px solid ${props => (props.theme.colors && props.theme.colors.border) || '#e5e7eb'};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'};
`;



// WEBPACK FOOTER //
// ./src/design-system/molecules/Modal/components/ModalStyles.js